import { render, staticRenderFns } from "./ListCustomer.vue?vue&type=template&id=37bc2ccc&scoped=true&"
import script from "./ListCustomer.vue?vue&type=script&lang=js&"
export * from "./ListCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ListCustomer.vue?vue&type=style&index=0&id=37bc2ccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bc2ccc",
  null
  
)

export default component.exports